(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4280],{

/***/ 25970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePickBy = __webpack_require__(63012),
    hasIn = __webpack_require__(79095);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ 63012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSet = __webpack_require__(10611),
    castPath = __webpack_require__(71811);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ 10611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    castPath = __webpack_require__(71811),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 78718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePick = __webpack_require__(25970),
    flatRest = __webpack_require__(99021);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ 75288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuspenseLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function SuspenseLoading(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)),
        children: props.children
    });
};


/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollTo; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var supportsNativeSmoothScroll = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function scrollTo(param) {
    var element = param.element, _top = param.top, top = _top === void 0 ? 0 : _top, _left = param.left, left = _left === void 0 ? 0 : _left;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) {
        return;
    }
    element = (element === null || element === void 0 ? void 0 : element.scrollTo) && typeof (element === null || element === void 0 ? void 0 : element.scrollTo) === "function" ? element : window;
    if (!element) {
        return;
    }
    if (supportsNativeSmoothScroll) {
        element.scrollTo({
            top: top,
            left: left,
            behavior: "smooth"
        });
        return;
    }
    try {
        element.scrollTo(left, top);
    } catch (error) {
        try {
            element.scrollTop = top;
            element.scrollLeft = left;
        } catch (error) {}
    }
};


/***/ }),

/***/ 77723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useClearTable; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation setUserPreferencesClearTable($websiteId: ID, $tableName: String) {\n            preferences: setUserPreferences(websiteId: $websiteId, tableName: $tableName) {\n              _id\n              tableName\n            }\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useClearTable() {
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMutate */ .Tu)();
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return {
        clearTable: _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject()),
                            variables: {
                                websiteId: websiteId,
                                tableName: null
                            }
                        });
                    case 2:
                        sessionStorage.removeItem("onTable");
                        sessionStorage.removeItem("orderGroupId");
                        sessionStorage.removeItem("onTableModal");
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    };
}


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 97744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Options; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/index.js
var lib = __webpack_require__(5275);
// EXTERNAL MODULE: ./src/components/Address/index.tsx + 11 modules
var Address = __webpack_require__(21916);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var SuspenseLoading_Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./src/helpers/addresses/models.ts
var models = __webpack_require__(88315);
// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./src/helpers/misc/scrollTo.ts
var scrollTo = __webpack_require__(55192);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/hooks/useShouldUseNewAddressesUI.ts
var useShouldUseNewAddressesUI = __webpack_require__(17664);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/components/LoadingText/index.tsx + 1 modules
var LoadingText = __webpack_require__(69840);
// EXTERNAL MODULE: ./src/page-components/Order/Options/MobileSkeleton/styles.module.css
var styles_module = __webpack_require__(95834);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/MobileSkeleton/index.tsx




function MobileSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).buttons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).square,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {
                            color: "#eaeaea",
                            lineHeight: 80
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).square,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {
                            color: "#eaeaea",
                            lineHeight: 80
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).square,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {
                            color: "#eaeaea",
                            lineHeight: 80
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {
                color: "#eaeaea",
                lineHeight: 40
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/hooks/useClearTable.tsx
var useClearTable = __webpack_require__(77723);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/Options/styles.module.css
var Options_styles_module = __webpack_require__(88939);
var Options_styles_module_default = /*#__PURE__*/__webpack_require__.n(Options_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/OptionsTableServe.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var OptionsTableServe = function(props) {
    var ref = _slicedToArray((0,useSessionStorageState/* default */.Z)("onTable"), 1), onTable = ref[0];
    var preferences = props.preferences;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.options.optionsTableServe"
    }).t;
    var clearTable = (0,useClearTable/* useClearTable */.l)().clearTable;
    if (onTable) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Options_styles_module_default()).changeTableContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Est\xe1s en la ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                        children: [
                            "Mesa ",
                            preferences.tableName
                        ]
                    }),
                    preferences.store && preferences.store.name !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            " ",
                            "del ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    "Local ",
                                    preferences.store.name
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: function() {
                    return clearTable();
                },
                children: t("buttonChangePreferences")
            })
        ]
    });
};
/* harmony default export */ var Options_OptionsTableServe = (OptionsTableServe);

// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx + 1 modules
var UpdateBasicOptions = __webpack_require__(82096);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/index.tsx
function Options_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Options_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Options_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Options_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Options_slicedToArray(arr, i) {
    return Options_arrayWithHoles(arr) || Options_iterableToArrayLimit(arr, i) || Options_unsupportedIterableToArray(arr, i) || Options_nonIterableRest();
}
function Options_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Options_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Options_arrayLikeToArray(o, minLen);
}



















function Options(props) {
    var container = (0,useRef/* default */.Z)();
    var ref = Options_slicedToArray((0,useState/* default */.Z)(""), 2), className = ref[0], setClassName = ref[1];
    var ref1 = Options_slicedToArray((0,useState/* default */.Z)(false), 2), hiddenPrice = ref1[0], setHiddenPrice = ref1[1];
    var preferences = props.preferences, website = props.website, layout = props.layout;
    var shouldUseNewAddressesUI = (0,useShouldUseNewAddressesUI/* default */.Z)();
    (0,lib/* useOnEvent */.dh)("hiddenPriceProductOpened", _asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setClassName((Options_styles_module_default()).shake);
                    (0,scrollTo/* default */.Z)({
                        top: 0
                    });
                    setHiddenPrice(true);
                    _ctx.next = 5;
                    return (0,sleep/* default */.Z)(1500);
                case 5:
                    setClassName("");
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    (0,react.useEffect)(function() {
        setHiddenPrice(false);
    }, [
        preferences
    ]);
    if (!preferences.cart) {
        if (layout === "mobile") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSkeleton, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Options_styles_module_default()).loading,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
        });
    }
    var hide = preferences.deliveryType === "serve" && preferences.tableName !== null;
    if (hide) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Options_OptionsTableServe, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classnames/* default */.Z)((Options_styles_module_default()).container, className, _defineProperty({}, (Options_styles_module_default()).hiddenPrice, hiddenPrice)),
        ref: container,
        children: [
            hiddenPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Necesitamos tu direcci\xf3n para poder continuar con el pedido"
            }) : null,
            shouldUseNewAddressesUI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading_Loading/* default */.Z, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Address.AddressForm, {
                    type: models/* AddressFormType.Form */.tv.Form,
                    websiteId: preferences.websiteId,
                    closeModal: function() {}
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateBasicOptions/* default */.Z, _objectSpread({
                showStoreName: website.showStoreName || null,
                layout: layout
            }, props))
        ]
    });
};


/***/ }),

/***/ 95834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_10cjV1FGWwGSj_aw6-oM3_","buttons":"_2w7HH7gtQSsZxfNhfpb-3B","square":"_3QsyC1y9UDQc7crxLGECH3"};

/***/ }),

/***/ 88939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2az75VpDmXIgyXSjOIlY5x content animated","orion-select__menu":"_2-PHF2K5-tu7GeSQFGkp7","shake":"_35LDvcZp8wU7TmRBnfZUg- shake","hiddenPrice":"_1tYgiqvylOgZhh0nN8QCj7","changeTableContainer":"_2kJjxG8XSNigPJK5jO0Ed6","loading":"_14NHpgOUYP6MuCWyak0C0j _2az75VpDmXIgyXSjOIlY5x content animated"};

/***/ }),

/***/ 5275:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = exports.dh = exports.BX = void 0;
const tslib_1 = __webpack_require__(70655);
const fireEvent_1 = (0, tslib_1.__importDefault)(__webpack_require__(93415));
exports.BX = fireEvent_1.default;
const useOnEvent_1 = (0, tslib_1.__importDefault)(__webpack_require__(80967));
exports.dh = useOnEvent_1.default;
const waitAndFire_1 = (0, tslib_1.__importDefault)(__webpack_require__(63921));
__webpack_unused_export__ = waitAndFire_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = (time) => new Promise(resolve => setTimeout(resolve, time));
//# sourceMappingURL=sleep.js.map

/***/ }),

/***/ 80967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(67294);
const store_1 = __webpack_require__(3496);
function useOnEvent(name, func, differs = null) {
    (0, react_1.useEffect)(() => {
        (0, store_1.addListener)(name, func);
        return () => {
            (0, store_1.removeListener)(name, func);
        };
    }, differs);
}
exports["default"] = useOnEvent;
//# sourceMappingURL=useOnEvent.js.map

/***/ }),

/***/ 63921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(70655);
const fireEvent_1 = (0, tslib_1.__importDefault)(__webpack_require__(93415));
const sleep_1 = (0, tslib_1.__importDefault)(__webpack_require__(2489));
async function waitAndFire(name, data) {
    const results = await (0, fireEvent_1.default)(name, data);
    if (results.length === 0) {
        await (0, sleep_1.default)(100);
        return await waitAndFire(name, data);
    }
    return results;
}
exports["default"] = waitAndFire;
//# sourceMappingURL=waitAndFire.js.map

/***/ })

}]);